import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

const { CountryCode } = Constants;

export const MXTaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    countryCode={CountryCode.MX}
    showTaxCert={false}
  />
);

MXTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
